import i18next from 'i18next'
import _ from 'lodash'
import { Fragment, useState } from 'react'
// import Link from "next/link";
// import { useRouter } from "next/router";
import { useTranslation } from 'react-i18next'
// import Backdrop from "../Backdrop/Backdrop";
// import Backdrop from '~components/Backdrop/Backdrop'
// import ModalConfirm from "../modal/ModalConfirm";
// import ModalConfirm from '~components/Modal/ModalConfirm'
// import classes2 from '../EditorInfo/EditorInfo.module.css'
// import { useStore } from "../../hooks-store/store";
import classes from './Language.module.css'

function Language(props) {
  // console.log('Language.js-props', props);
  // console.log(i18next.store.data);
  const [t] = useTranslation('translation')
  // const languageObject = props.i18nInfo ? props.i18nInfo.initialI18nStore : null
  const languageObject = i18next.store.data
  // console.log(languageObject)
  let languageList = []
  if (languageObject) {
    for (const key in languageObject) {
      // console.log(languageObject[key])

      if (languageObject[key].translation) {
        languageList.push({
          CODE: languageObject[key].translation.CODE,
          LANGUAGE: languageObject[key].translation.LANGUAGE,
          content: languageObject[key].translation,
        })
      }
    }
  }
  languageList = _.sortBy(languageList, ['LANGUAGE'])
  // console.log(languageList)

  // const { t } = useTranslation("common");

  // const router = useRouter();

  // const [state, dispatch] = useStore();

  const [showModal, setShowModal] = useState(false)
  // const [localeList, setLocaleList] = useState([]);

  // const { pathname } = router;
  // console.log(pathname);
  // const classes = ['text-sm', 'md:text-base', 'm-0.5', 'p-0.5'];

  // useEffect(() => {
  //   if (state.i18nInfo && state.i18nInfo.userConfig) {
  //     setLocaleList(state.i18nInfo.userConfig.i18n.locales);
  //   }
  // }, [state.i18nInfo]);

  return (
    <Fragment>
      <div
        // className={classes.languageBody}
        // className={classes2.editorInfoRow}
      >
        {/* Language: {router.locale.toUpperCase()} (Change) */}
        <span 
        // className={classes2.editorInfoRowContents} 
          style={{ cursor: 'default' }}>
          {t('language01', 'Language')}: <strong>{i18next.language.toUpperCase()}</strong>{' '}
          <button
            className="btnBase"
            onClick={() => {
              setShowModal(!showModal)
            }}
          >
            {t('language02', 'Change language')}
          </button>
        </span>
      </div>
      {showModal && (
        <ul className={classes.languageList}>
          {languageList.map((ln, index) => {
            // console.log(ln)
            // const current = ['uppercase', i18next.language === ln ? 'text-blue-600' : ''];
            // const path = pathname.replace(/\[lang\]/i, ln);
            // const linkPath = `/${ln.CODE}`
            return (
              <li key={ln.CODE}>
                <div>
                  <span
                    className={classes.languageListName}
                    onClick={() => {
                      setShowModal(false)
                      localStorage.setItem('userSelectLng', ln.CODE)
                      if (localStorage.getItem('lng') !== ln.CODE) {
                        i18next.changeLanguage(ln.CODE)
                        // window.location.reload();
                      }
                    }}
                  >
                    <span className={classes.languageCode}>{ln.CODE.toUpperCase()}</span>
                    <span className={classes.languageCodes}>({ln.LANGUAGE})</span>
                  </span>
                </div>
              </li>
            )
          })}
        </ul>
      )}

      {/* {showModal && 
        <Backdrop 
          onCancel={() => {setShowModal(false)}}
        />
      }
      {showModal && (
        <ModalConfirm>
          <div className={classes.languageClose}
            onClick={() => {setShowModal(false)}}
          >
            x
          </div>

          {
            <ul className={classes.languageList}>
              {languageList.map((ln, index) => {
                // console.log(ln)
                // const current = ['uppercase', i18next.language === ln ? 'text-blue-600' : ''];
                // const path = pathname.replace(/\[lang\]/i, ln);
                // const linkPath = `/${ln.CODE}`
                return (
                  <li key={ln.CODE}>
                    <div>
                      <span 
                        className={classes.languageListName}
                        onClick={() => {
                          setShowModal(false);
                          localStorage.setItem('userSelectLng', ln.CODE);
                          if (localStorage.getItem('lng') !== ln.CODE) {
                            i18next.changeLanguage(ln.CODE);
                            // window.location.reload();
                          }
                        }}
                      > 
                        <span className={classes.languageCode}>
                          {ln.CODE.toUpperCase()}
                        </span> 
                        <span className={classes.languageCodes}>
                          ({ln.LANGUAGE})
                        </span> 
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          }

        </ModalConfirm>
      )} */}
    </Fragment>
  )
}

export default Language
